import { render, staticRenderFns } from "./datenschutz.vue?vue&type=template&id=b73b541e&scoped=true&"
import script from "./datenschutz.vue?vue&type=script&lang=js&"
export * from "./datenschutz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73b541e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Ampps/www/mwst-rechner-pwa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VResponsive } from 'vuetify/lib'
installComponents(component, {VCardText,VContainer,VDivider,VFlex,VLayout,VProgressLinear,VResponsive})
